import React, {useState} from "react";
import styled from "styled-components";
import * as palette from "../Variables";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Placeholder from "../img/placeholder.jpg";
import AboutIntroImg from "../img/about-intro.png";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import AboutLottie from "../components/AboutLottie";

const StyledAboutIntro = styled.div`
    .row {
        display: flex;
        align-items: center;
    }
`;

const LottieWrapper = styled.div`
    width: 100%;
    height: 100%;
    max-width: 432px;
`;

const lottieStyle = {
    width: "140%",
    height: "100%",
    marginLeft: "-20%",
}

const AboutIntroLeft = styled.div`
    @media (min-width: 992px) {
        max-width: 550px;
        padding-right: 24px;
    }

    h1 {
        &.h2 {
            margin-bottom: 18px;

            @media (min-width: 768px) {
                font-size: 26px;
                margin-bottom: 24px;
            }
            
            @media (min-width: 830px) {
                font-size: 32px;
            }

            span {
                background: ${palette.gradientMain};
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                margin: 0;
            }
        }
    }
`;

const AboutIntroRight = styled.div`
    width: 100%;
    padding-top: 40px;

    @media (min-width: 992px) {
        padding-top: 0;
        padding-left: 24px;
    }

    img {
        width: 100%;
        object-fit: cover;
        border-radius: 8px;
        max-width: 450px;
    }
`;

const AboutIntro = () => {

    return (
        <StyledAboutIntro>
            <Container>
                <Row>
                    <Col xs={12} lg={7}>
                        <AboutIntroLeft>
                            <h1 className={"h2"}>Learn more&nbsp;<span>about me</span></h1>
                            <p>I'm <span class={"semibold"}>Courtney Sherrod</span>, a UX designer with 4+ years of experience designing accessible, intuitive digital experiences. I’ve worked on products ranging from a responsive global e&#8209;commerce website for engineers to AR tools supporting neurodivergent users, always adapting to new teams and user needs. I sweat the details that make great interfaces feel effortless.</p>
                            <p>I’ve been drawn to art since I could hold a paintbrush, which naturally led me to a career in design. My interest in UX design began during undergrad and deepened as I pursued my master's degree in human-computer interaction, where I explored interaction design, UX research, and visual design.</p>
                            <p className={"no-margin"}>Whether I’m conducting accessibility audits, crafting UI patterns, or prototyping new features, I value clarity, creativity, and thoughtful solutions. I advocate for digital experiences that are both inclusive and elegant, and I'm always experimenting with new tools, apps, and interfaces to sharpen my eye for what works and what doesn't.</p>
                        </AboutIntroLeft>
                    </Col>
                    <Col xs={12} lg={5}>
                        <AboutIntroRight>
                            <LottieWrapper>
                                <AboutLottie></AboutLottie>
                            </LottieWrapper>
                        </AboutIntroRight>
                    </Col>
                </Row>
            </Container>
        </StyledAboutIntro>
    )
}

export default AboutIntro;